window.megaMenu = function megaMenu() {

    $('.mainNavigation .hasChildren').hoverIntent({
        sensitivity: 10,
        interval: 80,
        over: function () {
            debugger;

            if (windowWidth > window.breakpoints.mobile) {

                if ($(this).find('a').first().attr('href') !== '/electric-cars') {
                    $(this).find('.dropdownWrap').fadeIn(200);
                }
            }

            lazyLoadImages();
        },
        //timeout: 150,
        out: function () {
            if (windowWidth > window.breakpoints.mobile) {
                $(this).find('.dropdownWrap').fadeOut(200);

                // remove active classes when menu closes
                $('.dropdownMainMenu li').removeClass('active');
                $('.dropdownSubMenu .menuList').removeClass('active fade');

                // reset first items
                setTimeout(function () {
                    $('.dropdownMainMenu li').eq(0).addClass('active');
                    $('.dropdownSubMenu .menuList').eq(0).addClass('active fade');
                }, 205);
            }
        }
    });

    $('.dropdownMainMenu li').on('hover', function () {
        var $this = $(this),
            index = $this.index(),
            menu_list = $('.menuList');

        $this.siblings().removeClass('active');
        $this.addClass('active');

        menu_list.removeClass('active fade');
        menu_list.eq(index).addClass('active fade');
    });
}

$(document).ready(function () {
    'use strict';

    megaMenu();
});
